import React from "react";
import { DownloadCsvButton } from "../../../components/download/DownloadCsvButton.js";
import "../../../components/download/DownloadTemplate.js";
import { useDownloadTransaction } from "../hooks.js";
function TransactionDownloadCsvButton(props) {
  const { isProgress, handleDownload } = useDownloadTransaction(props);
  return /* @__PURE__ */ React.createElement(DownloadCsvButton, { onClick: handleDownload, loading: isProgress, disabled: isProgress || props.total === 0 });
}
export {
  TransactionDownloadCsvButton
};
//# sourceMappingURL=DownloadCsvButton.js.map
